import { createTelemetryAPI } from '~/utils/telemetry'

export const settingsTelemetry = createTelemetryAPI(({ track }) => ({
  editOrgName(id: string, oldName: string, newName: string) {
    return track('Settings: Edit Organization Name', { id, oldName, newName })
  },
  clickInviteUser() {
    return track('Settings: Click Invite User Button')
  },
  inviteUsers(users: { role: number; userName: string }[]) {
    return track('Settings: Invite Users', { users })
  },
  confirmDeleteInviteUser(id: number) {
    return track('Settings: Confirm Delete Invite User Button', { id })
  },
  clickDeleteOrg() {
    return track('Settings: Click Delete Organization Button')
  },
  confirmDeleteOrg(id: string) {
    return track('Settings: Confirm Delete Organization', { id })
  },
  editUserOrgRole(id: number, role: string) {
    return track('Settings: Edit User Organization Role', { id, role })
  }
}))
